import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useLogtoAdmin } from "@/services/auth/logto-provider";
import { LexeIcon } from "@/components/ui/LexeLogo";

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useLogtoAdmin();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <LexeIcon size={64} className="mx-auto animate-pulse" />
          <p className="text-muted-foreground text-sm">Verifica sessione...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
